<template>
  <v-container class="order-tab">
    <v-row>
      <v-col>
        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="edit"
          :iconTooltip="$t('buttons:view')"
          :addBtnText="$t('buttons:add-specific', {specific: $t('book/issue:common.order')})"
          @clickedAddButton="createOrder"
          @clickedButton1="v => $refs.orderDocumentationDialog.viewDialog(v)"
          icon2="delete"
          :iconTooltip2="$t('buttons:delete')"
          @clickedButton2="openDeleteWindow"
          @updateTableData="updateTable"
          sort-by="id"
          :addBtn="!isTaskFinished"
          :sortDesc="true" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <OrderDocumentationDialog
          @closeDialog="updateData"
          :key="'orderDialog' + key"
          ref="orderDocumentationDialog" />
      </v-col>
    </v-row>
    <v-col>
      <TwoButtonDialog
          ref="deleteButton"
          :btn-text="$t('buttons:delete')"
          color="red"
          :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/issue:common.order')})"
          :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/issue:common.order')})"
          :button1-text="$t('buttons:cancel')"
          :button2-text="$t('buttons:delete')"
          @clickedButton1="$refs.deleteButton.showDialog = false"
          @clickedButton2="deleteOrder"
          hide-button
          hide-overlay
      />
    </v-col>
  </v-container>
</template>
<script>

import TaskDocumentationService from '@/modules/book/services/task-documentation/task-documentation-service';
import OrderDocumentationDialog from '@/modules/book/views/task/components/OrderDocumentationDialog.vue';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog.vue';
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated.vue';
import TaskDocumentation from '@/modules/book/data/task-documentation';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'OrderTab',
  components: {TwoButtonDialog, OrderDocumentationDialog, DataTablePaginated},
  props: {
    taskInfo: {},
    isTaskFinished: Boolean
  },
  data() {
    return {
      orderDocumentationToRemove: {},
      key: 1
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('book/issue:common.supplier'), value: 'supplier', default: true, sortable:false },
        { text: this.$t('book/issue:common.implementation-date'), value: 'startDate', default: true, sortable:false },
        { text: "", value: "controls", sortable: false, align: 'end' }
      ];
    }
  },
  methods: {
    createOrder() {
      this.$refs.orderDocumentationDialog.openCreationDialog(
        {
          documentType: DocumentType.OFFER_TASK,
          taskId: this.taskInfo.id,
          customerId: this.taskInfo.manager
        }
      );
    },
    updateTable(options, search) {
      if (!this.taskInfo || !this.taskInfo.id) return;

      TaskDocumentationService.readAllOrderPaginatedByTaskIdFromAPI(
        this.taskInfo.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, TaskDocumentation);
            this.$refs.table.fillTableData(response.data);
          }
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/issue:common.order')}));
          this.$logger.error(error)
        }
      )
    },
    updateData() {
      this.$refs.table.callTableUpdate();
      this.key++;
      this.$emit('updateData');
    },
    openDeleteWindow(oderDocumentation) {
      this.$refs.deleteButton.showDialog = true;
      this.orderDocumentationToRemove = oderDocumentation;
    },
    deleteOrder() {
      if (!this.orderDocumentationToRemove || !this.orderDocumentationToRemove.id) return;

      TaskDocumentationService.delete(
        this.orderDocumentationToRemove.id,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success',
              {name: this.$t('book/issue:common.order')}));
          this.$refs.table.callTableUpdate();
          this.orderDocumentationToRemove = {};
          this.$refs.deleteButton.showDialog = false;
          this.updateData();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure',
              {name: this.$t('book/issue:offerDocumentation')}));
          this.$refs.table.callTableUpdate();
          this.orderDocumentationToRemove = {};
          this.$refs.deleteButton.showDialog = false;
        }
      );
    },
    clearData() {

    }
  }
}
</script>